




















import axios from "axios";
import Vue from "vue";

export default Vue.extend({
	name: "Home",
	components: {},
	data() {
		return {
			org: null as string | null,
			orgFound: false as boolean,
			loading: true as boolean,
         languages: [] as any,
         langCodes: 
         [
				{ language: "Suomi", code: "fi" },
				{ language: "Svenska", code: "se" },
				{ language: "English", code: "en" }
         ]         
		};
	},
	mounted() {
		if (this.$route.params.org) {
			this.org = this.$route.params.org;
		}
		this.checkOrgs();
      this.languagesInUse();
      
	},
	methods: {
		chooseLanguage(org: string, lang: string) {
			let payload = {
				org: org,
				lang: lang,
			};
			this.$i18n.locale = lang;
			this.$store.commit("setOrgLang", payload);
			this.$router.push({
				name: "Authenticate",
				params: { lang: lang, org: org },
			});
		},
		checkOrgs() {
			//palauttaa true, jos organisaatio löytyy. Muuten errorin. 
			//Näin koska header pitää tällä hetkellä sisältää oikean organisaatio GUIDin
			axios.get(`auth/CheckOrgs/${this.org}`, {'headers': {"org": this.org}}).then(r => {
				this.orgFound = r.data;
			}).catch(ex => {
				if(ex.error) {
					this.orgFound = false
				}
			})
			.finally(() => {
				this.loading = false;
			})
		},
      languagesInUse(){
         axios.get(`auth/languages/${this.org}`, {'headers': {"org": this.org}}).then(r => {
				this.languages = r.data;
            if(r.data=="" || r.data==undefined || r.data == null){
               this.languages = ["fi"];
            }
			}).catch(ex => {
				if(ex.error) {
					this.languages = ["fi"];
				}
			})
      }
	},
});
